import { render, staticRenderFns } from "./ReportGroup.vue?vue&type=template&id=0c2af1e6&scoped=true&"
import script from "./ReportGroup.vue?vue&type=script&lang=js&"
export * from "./ReportGroup.vue?vue&type=script&lang=js&"
import style0 from "../report-card.css?vue&type=style&index=0&lang=css&"
import style1 from "./ReportGroup.vue?vue&type=style&index=1&id=0c2af1e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2af1e6",
  null
  
)

export default component.exports